import React, { useState } from "react";
import { requestBrochureDownload } from "../utils/brochureDownload";

const OptimizingPage = () => {
  const [brochureEmail, setBrochureEmail] = useState("");
  const [brochureError, setBrochureError] = useState("");
  const [brochureSubmitting, setBrochureSubmitting] = useState(false);

  return (
    <>
      {/* Hero Banner Section */}
      <section className="optimising-hero-section">
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="hero-content-right">
                <h1 className="optimising-title">
                  Optimising <span className="resources-text">Resources</span>
                </h1>
                <div className="gear-icons">
                  <i className="fas fa-cog gear-icon"></i>
                  <i className="fas fa-lightbulb gear-icon"></i>
                  <i className="fas fa-users gear-icon"></i>
                  <i className="fas fa-chart-line gear-icon"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Us Content Section */}
      <section className="page-about-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <h2 className="page-about-title">About us</h2>

              <p className="page-about-text">
                NCG Corporate is a manufacturer and exporter of customized
                engineering steel products. NCG management has more than 30+
                years of years in manufacturing, international business,
                procurement, and supply chain. The director is a Quality
                certified auditor and Six Sigma certified. The team provides a
                systematic approach to formulating a seamless supply chain for
                its clients with deep knowledge of sourcing, production, design
                and processes. Best in class manufacturing facility augmented
                with vast industry experience enhances the final value delivered
                to its customers.
              </p>

              <p className="page-about-text">
                NCG is fully equipped to deliver various sheet metal customized
                engineered components, fencing products, fasteners and Ubolts
                and construction & building hardware products in different
                finishes like hot dip galvanising, electroplating, and powder
                coating. We have an internal design team to develop products
                from drawings/samples/sketches to provide the best sample in the
                shortest possible time. The production team has deep expertise
                in tool & die development to minimize the development time and
                provide cost-effective solutions to meet our customer's needs.
                We study & analyse the application of the product/component
                being developed and recommend our customer's alternate raw
                materials/processes and finishes in achieving economical
                solutions thus creating a win-win situation for both NCG & its
                customers.
              </p>

              <p className="page-about-text">
                NCG management team also has vast experience in procurement,
                supply chain, and logistics, thus addressing a major concern of
                its customers of quality and timely deliveries through pre-
                -mass production & pre-dispatch inspection reports and regular
                status updates of production and delivery. We continuously work
                with our customers to find the most optimised way of packaging &
                transportation to reduce the cost.
              </p>

              <p className="page-about-text">
                This expertise also enables NCG to extend procurement, supplier
                development and inspections, as a service to its existing & new
                customers in delivering support for other products. This
                provides customers with a seamless buying experience in
                fulfilling all their needs as a single window business
                operations/outsourcing from India
              </p>

              <p className="page-about-text">
                This end-to-end manufacturing to buying support makes the NCG
                team stand out from its competition and delights customers.
              </p>
            </div>

            <div className="col-lg-4">
              <div className="page-sidebar">
                <div className="page-nav-links">
                  <a href="#vision-mission" className="page-nav-link active">
                    Vision & Mission
                  </a>
                  <a href="#team" className="page-nav-link">
                    Our Team
                  </a>
                  <a href="#infrastructure" className="page-nav-link">
                    Infrastructure
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Download Brochure Section */}
      <section className="page-download-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="download-image">
                {/* Steel pipes/manufacturing image placeholder */}
                <div className="manufacturing-image-placeholder"></div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="download-content">
                <h3 className="download-title">Download Our Brochure</h3>
                <form
                  className="download-form"
                  onSubmit={async (e) => {
                    e.preventDefault();
                    setBrochureError("");
                    setBrochureSubmitting(true);
                    const result = await requestBrochureDownload(brochureEmail);
                    setBrochureSubmitting(false);
                    if (!result.ok) {
                      setBrochureError(result.error);
                      return;
                    }
                    setBrochureEmail("");
                  }}
                  noValidate
                >
                  <label htmlFor="brochure-email-optimizing" className="form-label">
                    Email Address
                  </label>
                  <input
                    type="email"
                    id="brochure-email-optimizing"
                    name="brochure-email"
                    className="form-control download-email-input"
                    placeholder="Email Address*"
                    value={brochureEmail}
                    onChange={(e) => setBrochureEmail(e.target.value)}
                    autoComplete="email"
                  />
                  <button
                    type="submit"
                    className="download-btn"
                    disabled={brochureSubmitting}
                  >
                    Know More <i className="fas fa-arrow-right ms-2"></i>
                  </button>
                  {brochureError ? (
                    <p className="download-brochure-error" role="alert">
                      {brochureError}
                    </p>
                  ) : null}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer Information Section */}
      <section className="page-footer-info-section">
        <div className="container">
          <div className="row">
            {/* Column 1: Spotlight */}
            <div className="col-lg-4 col-md-6">
              <div className="info-column">
                <h6 className="info-title">Spotlight</h6>
                <h5 className="info-heading">Exports of Fencing Accessories</h5>
                <ul className="info-text spotlight-copy-list">
                  <li>
                    Exports of premium fencing accessories, crafted with
                    precision and strength.
                  </li>
                  <li>
                    Engineered for durability, ensuring long-lasting performance
                    in every environment.
                  </li>
                  <li>
                    Manufactured with high-quality materials, meeting global
                    standards and demands.
                  </li>
                  <li>
                    Trusted worldwide for reliability, innovation, and superior
                    finishing.
                  </li>
                </ul>
              </div>
            </div>

            {/* Column 2: Address */}
            <div className="col-lg-4 col-md-6">
              <div className="info-column">
                <h5 className="info-heading">Address</h5>
                <div className="address-info">
                  <p>
                    <strong>Registered Office:</strong>
                  </p>
                  <p>
                    SCO: 117/118(2nd Floor), Sector -17/B,
                    <br />
                    Chandigarh, India, Pin- 160017
                  </p>
                  <p>
                    <strong>Phone:</strong> 0172-4014825
                  </p>
                  <p>
                    <strong>Cell no:</strong> +91-9779044006
                  </p>
                  <p>
                    <strong>Email:</strong> info@ncgcorporate.com
                  </p>
                </div>
              </div>
            </div>

            {/* Column 3: Factory/Corporate Office */}
            <div className="col-lg-4 col-md-6">
              <div className="info-column">
                <h5 className="info-heading">Factory/Corporate Office:</h5>
                <div className="address-info">
                  <p>
                    <strong>Plot No.</strong> C-134, Industrial Area Phase VIII,
                    <br />
                    Sector 72, SAS Nagar Mohali, Punjab,
                    <br />
                    India, Pin- 160071
                  </p>
                  <p>
                    <strong>Cell:</strong> +91-9877078268 / +91-9779044006
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OptimizingPage;
